<template>
  <div v-if="show" id="sidebar_menu" class="sidebar_menu" data-testid="sidebar_menu">
    <div class="sidebar_content" data-testid="sidebar_content">
      <logo
        :show-cloudapp-link="false"
        :for-sidebar="true"
      >
      </logo>
      <div v-for="menuitem in menuList" v-bind:key="menuitem.name" :id="menuitem.name" v-b-tooltip.hover.right :title="menuitem.name">
        <a :href="menuitem.href" :data-testid="'sidebar-menu-' + menuitem.name">
          <img class="menu-img" :src="menuitem.image" :data-testid="'sidebar-menu-img-' + menuitem.name">
        </a>
      </div>
    </div>
    <div class="sidebar_footer" data-testid="sidebar_footer">
      <a v-if="gon.show_prize_steps" v-b-modal.prize-steps-modal class="d-none d-md-block prize-steps-btn mb-3" data-testid="prize_steps">
        <radial-progress-bar
          :diameter="40"
          :completed-steps="gon.user_onboarding_achievements.completed"
          :total-steps="gon.user_onboarding_achievements.total"
          :stroke-width="3"
          inner-stroke-color="#F8F8F8"
          start-color="#007AFF"
          stop-color="#007AFF"
          :inner-stroke-width="3"
          v-b-tooltip.hover.right
          :title="'Prize Steps: ' + gon.user_onboarding_achievements.completed + ' of ' + gon.user_onboarding_achievements.total "
        >
          <img class="prize_step_img" :src="PrizeImage">
        </radial-progress-bar>
      </a>
      <invite-member-button
        v-if="showInviteMembers"
        :is-personal="isPersonal"
      >
      </invite-member-button>
    </div>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'
import PrizeImage from '@img/prize@2x.png'
import ActivityImage from '@img/activity.svg';
import DashboardImage from '@img/dashboard.svg';
import IntegrationsImage from '@img/integrations.svg';
import CollectionImage from '@img/collection.svg';
import InviteMemberButton from '@cmp/invite_member_button.vue';
import Logo from '@cmp/logo.vue';
import NavMenu from '@cmp/nav_menu.vue';

export default {
  props: {
    profileMenu: String
  },
  components: {
    Logo,
    NavMenu,
    RadialProgressBar,
    InviteMemberButton,
  },
  data: function() {
    return {
      PrizeImage,
      menuList: [
        {
          name: "Recent",
          image: ActivityImage,
          href: this.$root.routes.dashboard_activity_path()
        },
        {
          name: "Dashboard",
          image: DashboardImage,
          href: this.$root.routes.dashboard_path()
        },
        {
          name: "Integrations",
          image: IntegrationsImage,
          href: "https://getcloudapp.com/integrations"
        },
        {
          name: "Collections",
          image: CollectionImage,
          href: this.$root.routes.collections_path()
        },
      ]
    }
  },
  computed: {
    show: function () {
      return !(this.$root.zoomed || this.$route.name == "annotate");
    },
    showInviteMembers: function () {
      return this.$root.userLoggedIn;
    },
    isPersonal: function () {
      return this.$root.currentOrganization.attributes.personal;
    }
  }
}
</script>

<style scoped lang="scss">
@import "application.scss";

.sidebar_menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  height: 100%;
  width: 4.5rem;
  background: white;
  z-index: 10;
  padding: 1.4rem 1rem;
  box-shadow: inset -1px 0 0 0 #d8d8d8;
  text-align: center;

  .sidebar_content {
    height: 87%;

    .logo-container {
      .navbar-brand {
        width: unset;
      }
      .logo {
        width: 2rem;
        height: 1.375rem;
        margin-bottom: 2rem;
        object-fit: contain;
      }
    }

    .menu-img {
      width: 1rem;
      height: 1rem;
      margin: 1rem 0rem;
      object-fit: contain;
    }
  }
  .prize_step_img {
    width: 0.8rem;
  }
}
@media (max-width: 767px) {
  .sidebar_menu {
    display: none;
  }
}
</style>
